import { useTheme } from 'styled-components';

import { CustomSvg, SvgIconDefaultProps } from '@libs/components';

const WithdrawIconGe: React.FC<SvgIconDefaultProps> = ({
  className,
  testId = 'withdrawIcon',
  color,
}) => {
  const { colors } = useTheme();
  const iconColor = color ? color : colors.interactive.brandColor;

  return (
    <CustomSvg
      className={className}
      data-cy={testId}
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
    >
      <path
        d="M1.6626 16.04C1.6626 16.6025 1.89779 17.144 2.33154 17.5415C2.73404 17.9115 3.2801 18.125 3.8501 18.125L16.3501 18.125C16.9201 18.125 17.4662 17.9115 17.8687 17.5415C18.3024 17.144 18.5376 16.6025 18.5376 16.04L18.5376 4.58496C18.5376 4.02246 18.3024 3.481 17.8687 3.0835C17.4662 2.7135 16.9201 2.5 16.3501 2.5L15.1001 2.5C14.5826 2.5 14.1626 2.92 14.1626 3.4375C14.1626 3.955 14.5826 4.375 15.1001 4.375L16.3501 4.375C16.4438 4.375 16.5341 4.40289 16.5991 4.46289C16.6354 4.49539 16.6626 4.53871 16.6626 4.58496L16.6626 16.04C16.6626 16.0863 16.6354 16.1296 16.5991 16.1621C16.5341 16.2221 16.4438 16.25 16.3501 16.25L3.8501 16.25C3.75635 16.25 3.66607 16.2221 3.60107 16.1621C3.56482 16.1296 3.5376 16.0863 3.5376 16.04L3.5376 4.58496C3.5376 4.53871 3.56482 4.49539 3.60107 4.46289C3.66607 4.40289 3.75635 4.375 3.8501 4.375L5.1001 4.375C5.6176 4.375 6.0376 3.955 6.0376 3.4375C6.0376 2.92 5.6176 2.5 5.1001 2.5L3.8501 2.5C3.2801 2.5 2.73404 2.7135 2.33154 3.0835C1.89779 3.481 1.6626 4.02246 1.6626 4.58496L1.6626 16.04ZM6.6626 5.3125C6.6626 5.5525 6.75535 5.79162 6.93848 5.97412C7.30348 6.34037 7.89672 6.34037 8.26172 5.97412L9.1626 5.07324L9.1626 11.5625C9.1626 12.08 9.5826 12.5 10.1001 12.5C10.6176 12.5 11.0376 12.08 11.0376 11.5625L11.0376 5.07324L11.9385 5.97412C12.3035 6.34037 12.8967 6.34037 13.2617 5.97412C13.628 5.60912 13.628 5.01588 13.2617 4.65088L10.7617 2.15088C10.3955 1.78463 9.80473 1.78463 9.43848 2.15088L6.93848 4.65088C6.75535 4.83338 6.6626 5.0725 6.6626 5.3125Z"
        fill={iconColor}
      />
    </CustomSvg>
  );
};
export default WithdrawIconGe;
